import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';
import BMMazeBanner from './BMMazeBanner';
import BMLNFPSFBanner from './BMLNFPSFBanner';
import BMCPBanner from './BMCPBanner';
import FNLBanner from './FNLBanner';
import SummerBanner from './SummerBunner';
import { READING, ESPANOL } from '../../constants/applications';

const MeasureBannersContainer = ({ studentUid, classId }) => {
    const { selectedAppGroup } = useAppContext();
    const { isBannerVisible, isBannerAvailable, isSummerPeriodAvailable } = useBannerContext();

    const isBMMazeBannerVisible = isBannerVisible(classId, studentUid, 'isBMMazeBannerVisible');
    const isBMCPBannerVisible = isBannerVisible(classId, studentUid, 'isBMCPBannerVisible');
    const isBMLNFPSFBannerVisible = isBannerVisible(classId, studentUid, 'isBMLNFPSFBannerVisible');
    const isFNLBannerVisible = isBannerVisible(classId, studentUid, 'isFNLBannerVisible');
    const isSummerBannerVisible = isBannerVisible(classId, studentUid, 'isSummerBannerVisible');

    const isSummerBannerAvailable = isSummerPeriodAvailable();
    const isMazeBannerAvailable = isBannerAvailable(classId, studentUid, 'isMazeBannerAvailable');
    const isCPBannerAvailable = isBannerAvailable(classId, studentUid, 'isCPBannerAvailable');
    const isLNFPSFMeasuresInGradeTwoAvailable = isBannerAvailable(
        classId,
        studentUid,
        'isLNFPSFBannerAvailable',
    );
    const isFNLAvailable = isBannerAvailable(classId, studentUid, 'isFNLBannerAvailable');

    const banners = [
        {
            id: 'summer-banner',
            isAvailable: isSummerBannerAvailable && isSummerBannerVisible,
            banner: <SummerBanner studentUid={studentUid} />,
            availableForApplicationGroup: READING,
        },
        {
            id: 'maze-banner',
            isAvailable: !isSummerBannerAvailable && isMazeBannerAvailable && isBMMazeBannerVisible,
            banner: <BMMazeBanner studentUid={studentUid} />,
            availableForApplicationGroup: READING,
        },
        {
            id: 'bm-cp-banner',
            isAvailable: isCPBannerAvailable && isBMCPBannerVisible,
            banner: <BMCPBanner studentUid={studentUid} />,
            availableForApplicationGroup: ESPANOL,
        },
        {
            id: 'lnf-psf-banner',
            isAvailable: isLNFPSFMeasuresInGradeTwoAvailable && isBMLNFPSFBannerVisible,
            banner: <BMLNFPSFBanner studentUid={studentUid} />,
            availableForApplicationGroup: READING,
        },
        {
            id: 'fnl-banner',
            isAvailable: isFNLBannerVisible && isFNLAvailable,
            banner: <FNLBanner studentUid={studentUid} />,
            availableForApplicationGroup: ESPANOL,
        },
    ];

    return (
        <>
            {banners
                .filter(
                    banner =>
                        banner.isAvailable &&
                        banner.availableForApplicationGroup === selectedAppGroup,
                )
                .map(item => (
                    <Fragment key={item.id}>{item.banner}</Fragment>
                ))}
        </>
    );
};

MeasureBannersContainer.propTypes = {
    studentUid: PropTypes.string.isRequired,
    classId: PropTypes.string.isRequired,
};

export default MeasureBannersContainer;
